placeholder for run applications